import { Box, Button, Fade, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Dbac from "./projects/dbac";
import Luc from "./projects/luc";
import Minerva from "./projects/minerva";
import Dms from "./projects/dms";
import Cartesi from "./projects/cartesi";
import AllProjects from "./projects/all-projects";

function Projects(props: Props) {
  const [open, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState(<div/>);
  const [scale, setScale] = useState(0);
  function handleOpen(type: string): any {
    switch (type) {
      case 'dbac':
        setModalContent(<Dbac />);
        break;
      case 'luc':
        setModalContent(<Luc />);
        break;
      case 'minerva':
        setModalContent(<Minerva />);
        break;
      case 'dms':
        setModalContent(<Dms />);
        break;
      case 'cartesi':
        setModalContent(<Cartesi />);
        break;
      default:
        setModalContent(<AllProjects />);
    }

    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  }

  useEffect(() => {
    setTimeout(() => {setScale(1);}, 0)
    setTimeout(() => {setScale(2);}, 200)
    setTimeout(() => {setScale(3);}, 400)
    setTimeout(() => {setScale(4);}, 600)
    setTimeout(() => {setScale(5);}, 800)
  }, [props.page])

  return (
    <div className={'container'} style={{filter: open ? 'blur(10px)' : ''}}>
      {/*<img className={'p-background'} alt={'Background'} style={{width: '100%'}} src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/posts/portfolio/background_projects.jpg'}></img>*/}
      <div className={'p-group'}>
        <h2>These are the highlighted projects I've joined</h2>
        <div className={'p-highlight-projects'}>
          <div className={'small-project dbac'} onClick={() => handleOpen('dbac')} style={{transform: props.page === 2 && scale >= 1 ? 'scale(1)' : 'scale(0)'}}>
            <div className={'dbac-img'}>
              <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/b44da90eecff2effb1b281ac33aaf747dde31178/posts/portfolio/dbac.svg'} alt={'DBAC'}/>
            </div>
            <div className={'dbac-info-container'}>
              <div className={'p-title'}>DBAC</div>
              <div className={'p-time'}>Time: 2020-11-10 ~ 2021-12-21</div>
              <div className={'p-type'}>Project type: Company</div>
              <div className={'p-roles'}>Roles: Backend developer</div>
              <div className={'p-company'}>Company name</div>
              <div className={'p-description'}>The system allows bots to play baccarat.</div>
            </div>
          </div>
          <div className={'small-project dms'} onClick={() => handleOpen('dms')} style={{transform: props.page === 2 && scale >= 2 ? 'scale(1)' : 'scale(0)'}}>
            <div className={'dms-img'}>
              <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/b44da90eecff2effb1b281ac33aaf747dde31178/posts/portfolio/dms.svg'} alt={'DMS'}/>
            </div>
            <div className={'dms-info-container'}>
              <div className={'p-title'}>DMS</div>
              <div className={'p-time'}>Time: 2020-11-10 ~ 2021-12-21</div>
              <div className={'p-type'}>Project type: Personal</div>
              <div className={'p-roles'}>Roles: Backend engineer</div>
              <div className={'p-company'}>Checking realtime data</div>
            </div>
          </div>
          <div className={'small-project cartesi'} onClick={() => handleOpen('cartesi')} style={{transform: props.page === 2 && scale >= 3 ? 'scale(1)' : 'scale(0)'}}>
            <div className={'cartesi-info-container'}>
              <div className={'p-title'}>Cartesi</div>
              <div className={'p-time'}>Time: 2020-11-10 ~ 2021-12-21</div>
              <div className={'p-type'}>Project type: Company</div>
              <div className={'p-roles'}>Roles: Backend engineer</div>
              <div className={'p-company'}>Building DApp</div>
            </div>
            <div className={'cartesi-img'}>
              <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/b44da90eecff2effb1b281ac33aaf747dde31178/posts/portfolio/cartesi.svg'} alt={'Cartesi'}/>
            </div>
          </div>
          <div className={'small-project minerva'} onClick={() => handleOpen('minerva')} style={{transform: props.page === 2 && scale >= 4 ? 'scale(1)' : 'scale(0)'}}>
            <div className={'cartesi-info-container'}>
              <div className={'p-title'}>Minerva</div>
              <div className={'p-time'}>Time: 2020-11-10 ~ 2021-12-21</div>
              <div className={'p-type'}>Project type: Company</div>
              <div className={'p-roles'}>Roles: Backend developer</div>
              <div className={'p-company'}>Database of events</div>
            </div>
            <div className={'cartesi-img'}>
              <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/b44da90eecff2effb1b281ac33aaf747dde31178/posts/portfolio/minerva.svg'} alt={'Minerva'}/>
            </div>
          </div>
          <div className={'small-project luc888'} onClick={() => handleOpen('luc')} style={{transform: props.page === 2 && scale >= 5 ? 'scale(1)' : 'scale(0)'}}>
            <div className={'luc-img'}>
              <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/b44da90eecff2effb1b281ac33aaf747dde31178/posts/portfolio/luc.svg'} alt={'LUC888'}/>
            </div>
            <div className={'luc-info-container'}>
              <div className={'p-title'}>LUC</div>
              <div className={'p-time'}>Time: 2020-11-10 ~ 2021-12-21</div>
              <div className={'p-type'}>Project type: Company</div>
              <div className={'p-roles'}>Roles: Backend developer</div>
              <div className={'p-company'}>A system allows users to play baccarat.</div>
            </div>
          </div>
        </div>
        {/*<Button onClick={() => handleOpen('all_projects')}>Show all project</Button>*/}
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        className={'p-modal'}
      >
        <Fade in={open}>
          <Box sx={style}>
            {modalContent}
            <div className={'p-btn-close-modal'}>
              <Button variant="outlined" onClick={handleClose}>Close</Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  )
}

export default Projects;

class Props {
  page: number;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  maxWidth: '700px',
  overflow: 'auto',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
